/* eslint-disable no-undef */
class QuantityInputSticky extends HTMLElement {
  /* eslint-enable no-undef */
  constructor () {
    super()
    this.min = parseInt(this.getAttribute('data-min'))
    this.max = parseInt(this.getAttribute('data-max'))
    this.step = parseInt(this.getAttribute('step'))
    this.value = parseInt(this.getAttribute('value'))
    this.input = this.querySelector('.quantity__input-sticky')
    this.plusButton = this.querySelector('[name="plus"]')
    this.minusButton = this.querySelector('[name="minus"]')
    this.isAvailable = document.querySelector('variant-selects[id*="__main"] > script') != null ? JSON.parse(document.querySelector('variant-selects[id*="__main"] > script').textContent).available : true

    if (isNaN(this.min)) this.min = 1
    if (isNaN(this.max)) this.max = Infinity
    if (isNaN(this.value)) this.value = 1

    if (this.plusButton) {
      this.plusButton.addEventListener('click', this.onPlusClick.bind(this))
    }
    if (this.minusButton) {
      this.minusButton.addEventListener('click', this.onMinusClick.bind(this))
    }

    const quantityPrice = this

    document.addEventListener('skio-price-update', function () {
      setTimeout(() => {
        quantityPrice.updateAddToCart()
      }, 300)
    })

    // Listen for the variantChanged event and update the isAvailable value
    // eslint-disable-next-line no-undef
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
      this.isAvailable = event.data.isAvailable
      this.currentPrice = event.data.currentPrice
      this.currentComparePrice = event.data.currentComparePrice
    })
  }

  onPlusClick () {
    if (this.value < this.max) {
      this.value = parseInt(this.input.value) + 1
      this.input.value = this.value

      if (this.input) {
        this.input.setAttribute('value', this.value)
      }

      const mobileQuantityInput = document.querySelector('.quantity__input-sticky-mobile')
      if (mobileQuantityInput) { mobileQuantityInput.value = this.value }

      const regularQuantityInput = document.querySelectorAll('.quantity__input')
      regularQuantityInput.forEach(input => {
        input.value = this.value
      })

      const regularQuantitySelect = document.querySelectorAll('.quantity__select')
      regularQuantitySelect.forEach(select => {
        select.setAttribute('data-value', this.value)
      })

      document.querySelectorAll('.quantity__select option').forEach(option => option.removeAttribute('selected'))
      const selectedOption = document.querySelector(`.quantity__select option[value="${this.value}"]`)
      if (selectedOption) {
        selectedOption.setAttribute('selected', 'selected')
      }

      setTimeout(() => {
        this.updateAddToCart()
      }, 100)
      this.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  onMinusClick () {
    const stickyQuantityInput = document.querySelector('.quantity__input-sticky')
    this.value = parseInt(stickyQuantityInput.value)
    if (this.value > this.min) {
      this.value = parseInt(stickyQuantityInput.value) - 1
      this.input.value = this.value

      if (stickyQuantityInput) {
        stickyQuantityInput.setAttribute('value', this.value)
      }

      const mobileQuantityInput = document.querySelector('.quantity__input-sticky-mobile')
      if (mobileQuantityInput) { mobileQuantityInput.value = this.value }

      const regularQuantityInput = document.querySelectorAll('.quantity__input')
      regularQuantityInput.forEach(input => {
        input.value = this.value
      })

      const regularQuantitySelect = document.querySelectorAll('.quantity__select')
      regularQuantitySelect.forEach(select => {
        select.setAttribute('data-value', this.value)
      })

      document.querySelectorAll('.quantity__select option').forEach(option => option.removeAttribute('selected'))
      const selectedOption = document.querySelector(`.quantity__select option[value="${this.value}"]`)
      if (selectedOption) {
        selectedOption.setAttribute('selected', 'selected')
      }
      setTimeout(() => {
        this.updateAddToCart()
      }, 100)
      this.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  updateAddToCart () {
    // eslint-disable-next-line no-undef
    updatePrices(this.currentPrice || null, this.currentComparePrice || null, this.isAvailable)
  }
}

// eslint-disable-next-line no-undef
customElements.define('quantity-input-sticky', QuantityInputSticky)

// eslint-disable-next-line no-undef
class QuantityInputStickyMobile extends HTMLElement {
  /* eslint-enable no-undef */
  constructor () {
    super()
    this.min = parseInt(this.getAttribute('data-min'))
    this.max = parseInt(this.getAttribute('data-max'))
    this.step = parseInt(this.getAttribute('step'))
    this.value = parseInt(this.getAttribute('value'))
    this.input = this.querySelector('.quantity__input-sticky-mobile')
    this.plusButton = this.querySelector('.quantity-sticky-mobile [name="plus"]')
    this.minusButton = this.querySelector('.quantity-sticky-mobile [name="minus"]')

    if (isNaN(this.min)) this.min = 1
    if (isNaN(this.max)) this.max = Infinity
    if (isNaN(this.value)) this.value = 1

    if (this.plusButton) {
      this.plusButton.addEventListener('click', this.onPlusClick.bind(this))
    }
    if (this.minusButton) {
      this.minusButton.addEventListener('click', this.onMinusClick.bind(this))
    }

    // Listen for the variantChanged event and update the isAvailable value
    // eslint-disable-next-line no-undef
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
      this.isAvailable = event.data.isAvailable
      this.currentPrice = event.data.currentPrice
      this.currentComparePrice = event.data.currentComparePrice
    })
  }

  onPlusClick () {
    if (this.value < this.max) {
      this.value = parseInt(this.input.value) + 1
      this.input.value = this.value

      if (this.input) {
        this.input.setAttribute('value', this.value)
      }

      const desktopQuantityInput = document.querySelector('.quantity__input-sticky')
      desktopQuantityInput.value = this.value

      const regularQuantityInput = document.querySelectorAll('.quantity__input')
      regularQuantityInput.forEach(input => {
        input.value = this.value
      })

      const regularQuantitySelect = document.querySelectorAll('.quantity__select')
      regularQuantitySelect.forEach(select => {
        select.setAttribute('data-value', this.value)
      })

      document.querySelectorAll('.quantity__select option').forEach(option => option.removeAttribute('selected'))
      const selectedOption = document.querySelector(`.quantity__select option[value="${this.value}"]`)
      if (selectedOption) {
        selectedOption.setAttribute('selected', 'selected')
      }
      setTimeout(() => {
        this.updateAddToCart()
      }, 100)
      this.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  onMinusClick () {
    this.value = parseInt(this.input.value)
    if (this.value > this.min) {
      this.value = parseInt(this.input.value) - 1
      this.input.value = this.value

      if (this.input) {
        this.input.setAttribute('value', this.value)
      }

      const desktopQuantityInput = document.querySelector('.quantity__input-sticky')
      desktopQuantityInput.value = this.value

      const regularQuantityInput = document.querySelectorAll('.quantity__input')
      regularQuantityInput.forEach(input => {
        input.value = this.value
      })

      const regularQuantitySelect = document.querySelectorAll('.quantity__select')
      regularQuantitySelect.forEach(select => {
        select.setAttribute('data-value', this.value)
      })

      document.querySelectorAll('.quantity__select option').forEach(option => option.removeAttribute('selected'))
      const selectedOption = document.querySelector(`.quantity__select option[value="${this.value}"]`)
      if (selectedOption) {
        selectedOption.setAttribute('selected', 'selected')
      }
      setTimeout(() => {
        this.updateAddToCart()
      }, 100)
      this.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  updateAddToCart () {
    // eslint-disable-next-line no-undef
    updatePrices(this.currentPrice || null, this.currentComparePrice || null, this.isAvailable)
  }
}

// eslint-disable-next-line no-undef
customElements.define('quantity-input-sticky-mobile', QuantityInputStickyMobile)

/* Setup Sticky ATC */
document.addEventListener('DOMContentLoaded', function () {
  function updateStickyButtonPosition () {
    // Support multiple header types:
    // 1. sticky-header element (sleepdoctor-header section)
    // 2. .sleepdoctor-header-offcanvas .header-wrapper (new offcanvas header)
    // 3. Fallback to any .header-wrapper
    const stickyHeaderElement = document.querySelector('sticky-header')
    const offcanvasHeader = document.querySelector('.sleepdoctor-header-offcanvas .header-wrapper')
    const fallbackHeader = document.querySelector('.header-wrapper')
    const headerElement = stickyHeaderElement || offcanvasHeader || fallbackHeader

    if (!headerElement) {
      console.warn('Sticky ATC: No header element found')
      return
    }

    let headerHeight = headerElement.offsetHeight
    const topbarElement = document.querySelector('.announcement-bar-section')
    const topbarHeight = topbarElement ? topbarElement.offsetHeight : 0
    headerHeight = headerHeight + topbarHeight

    const stickyButton = document.querySelector('.sticky-button.position--top')
    if (!stickyButton) return

    if (window.innerWidth > 767) {
      stickyButton.style.top = headerHeight + 'px'
      stickyButton.style.bottom = 'unset'
    } else {
      stickyButton.style.top = 'unset'
      stickyButton.style.bottom = '0px'
    }
  }

  window.addEventListener('resize', function () {
    updateStickyButtonPosition()
  })

  function offScreen () {
    const element = document.querySelector('.main-product .product__info-container .add-at-to-cart-button') || document.querySelector('#lp-featured-product .product__info-container .buy_buttons_new') || document.querySelector('.plan-picker-ab')
    const elementBottom = element.getBoundingClientRect().bottom
    const stickyButton = document.querySelector('.sticky-button')

    if (elementBottom <= 0) {
      stickyButton.style.position = 'fixed'
      stickyButton.style.visibility = 'visible'
      stickyButton.style.opacity = '1'
      updateStickyButtonPosition()
    } else {
      stickyButton.style.visibility = 'hidden'
      stickyButton.style.opacity = '0'
    }
  }
  offScreen()
  window.addEventListener('scroll', offScreen)

  const options = document.querySelectorAll('.sticky-button .product-form__input--dropdown').length
  if (options > 1) {
    const addToCartContainer = document.querySelector('.add-to-cart-container')
    if (addToCartContainer) {
      if (window.innerWidth <= 749) {
        addToCartContainer.classList.add('f-j-end')
        addToCartContainer.style.minHeight = '90px'
      }

      window.addEventListener('resize', function () {
        const addToCartContainer = document.querySelector('.add-to-cart-container')
        if (window.innerWidth <= 749) {
          addToCartContainer.classList.add('f-j-end')
          addToCartContainer.style.minHeight = '90px'
        } else {
          addToCartContainer.classList.remove('f-j-end')
          addToCartContainer.style.minHeight = '100%'
        }
      })
    }
  }

  function closeDrawerAndChat (event) {
    event.preventDefault()
    this.closest('cart-drawer').close()
  }

  const customizeButton = document.getElementById('btn-customize-product')
  if (customizeButton) {
    customizeButton.addEventListener('click', function (e) {
      e.preventDefault()
      this.classList.replace('hide-desktop', 'hide')
      this.parentElement.querySelector('.buy-btn-container').classList.remove('hide-mobile')
      this.parentElement.parentElement.querySelector('.select-container').classList.add('active')
    })
  }

  document.querySelectorAll('.drawer__close').forEach(function (drawerCloseButton) {
    drawerCloseButton.addEventListener('click', closeDrawerAndChat)
  })
})
